module.exports = "/static/assets/63e5827c1506216bd7c9927a4e5eb558.svg";